import { injectIntl } from 'react-intl';

import ProductSort from './ProductSort';

export default injectIntl(ProductSort);
